"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.map");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _responsiveTable = require("./responsiveTable");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _commonComponents = require("../commonComponents");

var _deleteButton = _interopRequireDefault(require("./buttons/deleteButton"));

var _react = _interopRequireDefault(require("react"));

var _renderTabularRow = _interopRequireDefault(require("./renderTabularRow"));

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var StyledTd = (0, _styledComponents["default"])(_responsiveTable.Td).withConfig({
  displayName: "renderTabularList__StyledTd",
  componentId: "sc-2mr7oa-0"
})(["padding:0 0 3px 15px;position:relative;width:20px;"]); //
// Render Tabular List
//

var _default = function _default(_ref) {
  var fields = _ref.fields,
      items = _ref.items,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      required = _ref.required,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["fields", "items", "meta", "required"]);
  var preparedFields = (0, _utils.prepareEmptyFields)(items);
  var _rest$config$disabled = rest.config.disabled,
      disabled = _rest$config$disabled === void 0 ? false : _rest$config$disabled;
  return /*#__PURE__*/_react["default"].createElement(_responsiveTable.Tbody, null, fields.map(function (row, index) {
    return /*#__PURE__*/_react["default"].createElement(_responsiveTable.Tr, {
      key: row
    }, (0, _renderTabularRow["default"])(_objectSpread(_objectSpread({}, rest), {}, {
      name: row,
      fields: items
    })), /*#__PURE__*/_react["default"].createElement(StyledTd, null, /*#__PURE__*/_react["default"].createElement(_deleteButton["default"], {
      onClick: function onClick() {
        return fields.remove(index);
      },
      id: "t-".concat(rest.config.name, "-").concat(index, "-delete"),
      disabled: disabled
    })));
  }), /*#__PURE__*/_react["default"].createElement(_responsiveTable.Tr, null, /*#__PURE__*/_react["default"].createElement(_responsiveTable.Td, {
    colSpan: "100%",
    style: {
      background: "transparent"
    }
  }, /*#__PURE__*/_react["default"].createElement(_commonComponents.AddButton, {
    disabled: disabled,
    onClick: function onClick() {
      return fields.push(preparedFields);
    },
    id: "t-add_list_button-".concat(rest.config.name),
    buttonStyle: "confirm"
  }, "+ add row"))));
};

exports["default"] = _default;